import React from 'react';
import ListingWrapper from './ListingWrapper';
import { useRouter } from 'next/router';
import { Image, Text } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import { buttonSizes, buttonTypes } from '@ui/atoms/utils/enums';
import texts from './en.json';

const FilteredOpportunityHeader = ({
    opportunitiesCount,
    isAuthorized,
    isFetching,
}) => {
    const router = useRouter();
    const navigateToActiveOpportunities = () => {
        const { sort, sortBy } = router.query;
        const baseUrl = isAuthorized
            ? '/opportunities'
            : '/active/opportunities';

        const queryParams = sort && sortBy ? { sort, sortBy } : undefined;

        router.push({ pathname: baseUrl, query: queryParams });
    };
    return (
        <ListingWrapper
            className=" bg-[url('/images/opportunities/ListingBackground.svg')] w-full bg-cover bg-center p-6"
            tag="header"
        >
            <div className="flex flex-col items-center md:items-start gap-4">
                <div className="flex items-center w-full">
                    <Button
                        buttonSize={buttonSizes.EXTRA_SMALL}
                        buttonType={buttonTypes.BORDERLESS}
                        buttonText={texts.BackToAllProducts}
                        onClick={navigateToActiveOpportunities}
                        prefixComponent={
                            <Image
                                src="/images/arrow-left-white.svg"
                                alt="arrow"
                                className="rotate"
                            />
                        }
                        className="self-center md:self-start p-0 mx-auto md:ml-0 md:mr-auto  md:p-0 !text-basicWhite"
                    />
                </div>
                {isFetching ? (
                    <div
                        className={`animate-pulse bg-basicWhite/40 rounded-md h-6 w-48`}
                    />
                ) : opportunitiesCount >= 0 ? (
                    <Text
                        content={`${opportunitiesCount} filtered bonds found`}
                        className="text-basicWhite h5-semibold md:h4-semibold"
                    />
                ) : null}
            </div>
        </ListingWrapper>
    );
};

export default FilteredOpportunityHeader;
